import React from "react";
import moment from "moment";
import { Row, Col, Carousel, Card } from "react-bootstrap";
import placeholderImage from "./../../assets/img/property-placeholder.jpg";
import UrlConstants from "./../../config/UrlConstants";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import { getTimeFromMins, formatNumber } from "./../Common/Common";

class TransactionsListWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  /**
   * @desc Get Progress bar data by transaction status and task status
   * @param {*} tasks
   * @param {*} status
   * @param {*} tranSts
   */
  getProgressBar(tasks, status, tranSts) {
    let totalCnt = tasks.length;
    let schCnt = 0;
    let overdurCnt = 0;
    let completedCnt = 0;

    //get count of scheduled task, over due tasks and completed tasks
    tasks.forEach((e) => {
      e.eventEndDate = new Date(
        moment(e.eventEndDate).format("MM/DD/YYYY ") + getTimeFromMins(e.time)
      );
      if (e.status == "SCHEDULED") {
        if (tranSts === "INPROGRESS") {
          schCnt = schCnt + 1;
          if (moment(e.eventEndDate) < moment()) {
            overdurCnt = overdurCnt + 1;
          }
        }
      } else if (e.status == "COMPLETED") {
        completedCnt = completedCnt + 1;
      }
    });

    let completed = 0;
    let overdue = 0;
    //get percentage for progress bar
    if (status == "completed") {
      completed = (completedCnt * 100) / totalCnt;
      return completed.toFixed(0);
    } else if (status == "overdue") {
      overdue = (overdurCnt * 100) / totalCnt;
      return overdue.toFixed(0);
    } else {
      return totalCnt;
    }
  }

  render() {
    if (
      this.props.dashboardTranscations &&
      this.props.dashboardTranscations.length == 0
    ) {
      return <div className="dash-no-records">No Records Found</div>;
    } else {
      return (
        <Carousel
          className="dash-slide-transaction"
          interval={0}
          indicators={false}
          fade={true}
          controls={
            this.props.dashboardTranscations &&
            this.props.dashboardTranscations.length <= 1
              ? false
              : true
          }
        >
          {this.props.dashboardTranscations &&
            this.props.dashboardTranscations.map((tran) => {
              return (
                <Carousel.Item
                  onClick={() => {
                    this.props.history.push("/artwork/detail/" + tran._id);
                  }}
                  key={tran._id}
                >
                  <Card>
                    <div className="dash-card-img">
                      {tran.property.image.length <= 0 ? (
                        <Card.Img variant="top" src={placeholderImage} />
                      ) : (
                        <Card.Img
                          variant="top"
                          src={
                            UrlConstants.AdminCreateTransactionUrl +
                            "/upload?id=" +
                            tran.ownerId +
                            "&img=" +
                            tran.property.image[0]
                          }
                        />
                      )}
                    </div>
                    <Card.Body className="p-3">
                      <h4 className="font-20 mb-0 color-blue-3">
                        {tran.property.street +
                          (tran.property.street1 != ""
                            ? ", " + tran.property.street1 + ""
                            : "") +
                          " " +
                          tran.property.city}
                      </h4>
                      <h5 className="font-18 color-blue-3">
                        {(tran.property.state
                          ? tran.property.state + " "
                          : "") + tran.property.zipcode}
                      </h5>
                      <Card.Title className="font-24 font-600">
                        ${formatNumber(tran.agreedOpenPrice)}
                      </Card.Title>
                      <Row>
                        <Col>
                          <div style={{ lineHeight: "1.1em" }}>
                            <span className="color-grey-2 font-14 font-500">
                              Status:&nbsp;
                            </span>
                            <span className="color-light-blue-1 font-14 font-600">
                              {tran.status}
                            </span>
                          </div>
                          <div style={{ lineHeight: "1.1em" }}>
                            <span className="color-grey-2 font-14 font-500">
                              Updated on:&nbsp;
                            </span>
                            <span className="color-grey-1 font-14 font-500">
                              {moment(tran.modifiedDate).format(
                                "MM/DD/YYYY, hh:mm a"
                              )}
                            </span>
                          </div>
                        </Col>
                        <Col align="right" className="col-auto">
                          <div className="trans-progress-circle">
                            <span className="circle-val">
                              {this.getProgressBar(
                                tran.events,
                                "completed",
                                tran.status
                              )}
                              %
                            </span>
                            {/* Foreground path */}
                            <CircularProgressbar
                              className="single-circle circle1"
                              value={this.getProgressBar(
                                tran.events,
                                "completed",
                                tran.status
                              )}
                              styles={buildStyles({
                                trailColor: "transparent",
                                strokeLinecap: "butt",
                                pathColor: "#45a751",
                              })}
                            />
                            {/* Foreground path */}
                            <CircularProgressbar
                              className="single-circle circle2"
                              value={this.getProgressBar(
                                tran.events,
                                "overdue",
                                tran.status
                              )}
                              styles={buildStyles({
                                trailColor: "transparent",
                                strokeLinecap: "butt",
                                pathColor: "#e88741",
                              })}
                            />
                            {/* Foreground path */}
                            <CircularProgressbar
                              className="single-circle circle3"
                              value={100}
                              styles={buildStyles({
                                trailColor: "transparent",
                                strokeLinecap: "butt",
                                pathColor: "#ebebeb",
                              })}
                            />
                          </div>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </Carousel.Item>
              );
            })}
        </Carousel>
      );
    }
  }
}

export default TransactionsListWidget;
